import { Component, OnInit, Inject, ElementRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/shared/Notification.service';

import { DistrictData } from 'src/app/shared/DistrictData.model';
import { DistrictDataService } from 'src/app/shared/DistrictData.service';
import { WardData } from 'src/app/shared/WardData.model';
import { WardDataService } from 'src/app/shared/WardData.service';

import { ProductGroup } from 'src/app/shared/ProductGroup.model';
import { ProductGroupService } from 'src/app/shared/ProductGroup.service';

import { CompanyInfo } from 'src/app/shared/CompanyInfo.model';
import { CompanyInfoService } from 'src/app/shared/CompanyInfo.service';
import { CompanyInfoVungTrong } from 'src/app/shared/CompanyInfoVungTrong.model';
import { CompanyInfoVungTrongService } from 'src/app/shared/CompanyInfoVungTrong.service';
import { CompanyInfoDonViDongGoiNongHo } from 'src/app/shared/CompanyInfoDonViDongGoiNongHo.model';
import { CompanyInfoDonViDongGoiNongHoService } from 'src/app/shared/CompanyInfoDonViDongGoiNongHo.service';

import { CompanyInfoVungTrongDocuments } from 'src/app/shared/CompanyInfoVungTrongDocuments.model';
import { CompanyInfoDonViDongGoiDocumentsService } from 'src/app/shared/CompanyInfoDonViDongGoiDocuments.service';

import { CompanyInfoVungTrongToaDo } from 'src/app/shared/CompanyInfoVungTrongToaDo.model';
import { CompanyInfoVungTrongToaDoService } from 'src/app/shared/CompanyInfoVungTrongToaDo.service';

import { PlanThamDinh } from 'src/app/shared/PlanThamDinh.model';
import { PlanThamDinhService } from 'src/app/shared/PlanThamDinh.service';

import { PlanThamDinhCompanyDocument } from 'src/app/shared/PlanThamDinhCompanyDocument.model';
import { PlanThamDinhCompanyDocumentService } from 'src/app/shared/PlanThamDinhCompanyDocument.service';
import { PlanThamDinhCompanyDocumentDetailComponent } from '../plan-tham-dinh-company-document-detail/plan-tham-dinh-company-document-detail.component';

import { ThanhVien } from 'src/app/shared/ThanhVien.model';
import { ThanhVienService } from 'src/app/shared/ThanhVien.service';

import { DanhMucATTPLoaiHoSo } from 'src/app/shared/DanhMucATTPLoaiHoSo.model';
import { DanhMucATTPLoaiHoSoService } from 'src/app/shared/DanhMucATTPLoaiHoSo.service';

import { DanhMucATTPTinhTrang } from 'src/app/shared/DanhMucATTPTinhTrang.model';
import { DanhMucATTPTinhTrangService } from 'src/app/shared/DanhMucATTPTinhTrang.service';

import { DanhMucATTPXepLoai } from 'src/app/shared/DanhMucATTPXepLoai.model';
import { DanhMucATTPXepLoaiService } from 'src/app/shared/DanhMucATTPXepLoai.service';

import { DanhMucThiTruong } from 'src/app/shared/DanhMucThiTruong.model';
import { DanhMucThiTruongService } from 'src/app/shared/DanhMucThiTruong.service';

import { MatHangXuatKhau } from 'src/app/shared/MatHangXuatKhau.model';
import { MatHangXuatKhauService } from 'src/app/shared/MatHangXuatKhau.service';
import { HistoryService } from 'src/app/shared/History.service';
import { History } from 'src/app/shared/History.model';


import * as maplibregl from 'maplibre-gl';
import { ThanhVienDetailComponent } from '../thanh-vien-detail/thanh-vien-detail.component';
import { ThanhVienDetail001Component } from '../thanh-vien-detail001/thanh-vien-detail001.component';
import { CompanyInfoVungTrongDocumentsDetailComponent } from '../company-info-vung-trong-documents-detail/company-info-vung-trong-documents-detail.component';

import { DownloadService } from 'src/app/shared/Download.service';
import { UploadService } from 'src/app/shared/Upload.service';
import { TinhTrangHoSoService } from 'src/app/shared/TinhTrangHoSo.service';
import { TinhTrangTDKTGSService } from 'src/app/shared/TinhTrangTDKTGS.service';

import { CompanyInfoDonViDongGoiService } from 'src/app/shared/CompanyInfoDonViDongGoi.service';
@Component({
  selector: 'app-company-info-don-vi-dong-goi-detail',
  templateUrl: './company-info-don-vi-dong-goi-detail.component.html',
  styleUrls: ['./company-info-don-vi-dong-goi-detail.component.css']
})
export class CompanyInfoDonViDongGoiDetailComponent implements OnInit {
  @ViewChild('CompanyInfoVungTrongSanPhamSort') CompanyInfoVungTrongSanPhamSort: MatSort;
  @ViewChild('CompanyInfoVungTrongSanPhamPaginator') CompanyInfoVungTrongSanPhamPaginator: MatPaginator;

  @ViewChild('CompanyInfoVungTrongThiTruongSort') CompanyInfoVungTrongThiTruongSort: MatSort;
  @ViewChild('CompanyInfoVungTrongThiTruongPaginator') CompanyInfoVungTrongThiTruongPaginator: MatPaginator;

  @ViewChild('CompanyInfoDonViDongGoiNongHoSort') CompanyInfoDonViDongGoiNongHoSort: MatSort;
  @ViewChild('CompanyInfoDonViDongGoiNongHoPaginator') CompanyInfoDonViDongGoiNongHoPaginator: MatPaginator;

  @ViewChild('CompanyInfoVungTrongDocumentsSort') CompanyInfoVungTrongDocumentsSort: MatSort;
  @ViewChild('CompanyInfoVungTrongDocumentsPaginator') CompanyInfoVungTrongDocumentsPaginator: MatPaginator;

  @ViewChild('CompanyInfoVungTrongDocumentsSort002') CompanyInfoVungTrongDocumentsSort002: MatSort;
  @ViewChild('CompanyInfoVungTrongDocumentsPaginator002') CompanyInfoVungTrongDocumentsPaginator002: MatPaginator;

  @ViewChild('HistorySort002') HistorySort002: MatSort;
  @ViewChild('HistoryPaginator002') HistoryPaginator002: MatPaginator;

  @ViewChild('CompanyInfoVungTrongToaDoSort') CompanyInfoVungTrongToaDoSort: MatSort;
  @ViewChild('CompanyInfoVungTrongToaDoPaginator') CompanyInfoVungTrongToaDoPaginator: MatPaginator;

  @ViewChild('PlanThamDinhCompanyDocumentSort') PlanThamDinhCompanyDocumentSort: MatSort;
  @ViewChild('PlanThamDinhCompanyDocumentPaginator') PlanThamDinhCompanyDocumentPaginator: MatPaginator;

  @ViewChildren('fileInput') fileInputs!: QueryList<ElementRef>;
  @ViewChildren('fileInput3') fileInputs3!: QueryList<ElementRef>;
  @ViewChildren('fileInputs4') fileInputs4!: QueryList<ElementRef>;
  
  @ViewChild('uploadGiamSatDuLuong') uploadGiamSatDuLuong!: ElementRef;
  @ViewChild('uploadGiamSatDuLuong1') uploadGiamSatDuLuong1!: ElementRef;
  @ViewChild('uploadGiamSatDuLuong2') uploadGiamSatDuLuong2!: ElementRef;
  @ViewChild('uploadGiamSatDuLuong3') uploadGiamSatDuLuong3!: ElementRef;
  @ViewChild('uploadGiamSatDuLuong4') uploadGiamSatDuLuong4!: ElementRef;
  
  domainURL: string = environment.DomainURL;

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<CompanyInfoDonViDongGoiDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {ID:number, IsStaff:boolean, CompanyInfoVungTrongDetail: CompanyInfoVungTrong},
    
    public NotificationService: NotificationService,

    public DownloadService: DownloadService,

    public ProductGroupService: ProductGroupService,

    public DistrictDataService: DistrictDataService,
    public WardDataService: WardDataService,
    public MatHangXuatKhauService: MatHangXuatKhauService,
    
    public CompanyInfoService: CompanyInfoService,
    public CompanyInfoVungTrongService: CompanyInfoVungTrongService,
    public CompanyInfoDonViDongGoiService: CompanyInfoDonViDongGoiService,
    public HistoryService: HistoryService,
    public CompanyInfoDonViDongGoiNongHoService: CompanyInfoDonViDongGoiNongHoService,

    public CompanyInfoDonViDongGoiDocumentsService: CompanyInfoDonViDongGoiDocumentsService,
    public CompanyInfoVungTrongToaDoService: CompanyInfoVungTrongToaDoService,
    public PlanThamDinhCompanyDocumentService: PlanThamDinhCompanyDocumentService,
    public PlanThamDinhService: PlanThamDinhService,
    public UploadService: UploadService,

    public ThanhVienService: ThanhVienService,
    public DanhMucATTPLoaiHoSoService: DanhMucATTPLoaiHoSoService,
    public DanhMucATTPTinhTrangService: DanhMucATTPTinhTrangService,
    public DanhMucATTPXepLoaiService: DanhMucATTPXepLoaiService,
    public DanhMucThiTruongService: DanhMucThiTruongService,
    public TinhTrangHoSoService: TinhTrangHoSoService,
    public TinhTrangTDKTGSService: TinhTrangTDKTGSService,

  ) { }
  IsStaff:boolean = false
  ngOnInit(): void {
    this.ThanhVienGetLogin();
    if(this.data.IsStaff){
      this.IsStaff = this.data.IsStaff;
    }
    this.ProductGroupSearch();
    
    this.DanhMucATTPLoaiHoSoSearch();
    this.DanhMucATTPTinhTrangSearch();
    this.DanhMucATTPXepLoaiSearch();
    this.DanhMucThiTruongSearch();
    this.ThanhVienSearch();
    this.CompanyInfoSearch();
    this.DistrictDataSearch();
    this.TimKiemMatHangXuatKhau();
    this.TimKiemLichSu();
    this.TinhTrangHoSoSearch();
    this.TinhTrangTDKTGSSearch();
    
    this.countResultSetting = 0;
    this.CompanyInfoVungTrongService.FormData.WardDataID = null
    this.CompanyInfoVungTrongService.FormData.DistrictDataID = null
    this.CompanyInfoVungTrongService.FormData.DanhMucATTPLoaiHoSoID = null
    this.CompanyInfoVungTrongService.FormData.DanhMucATTPTinhTrangID = null
    this.templateStaffList = [];
    this.templateStaffList.push(environment.BMGiamSatCSDG);
    this.templateStaffList.push(environment.BMKiemTraCSDG);
    this.templateStaffList.push(environment.BMCacGiaytoKhac);
  }
  TimKiemLichSu(){
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    // this.data.CompanyInfoVungTrongDetail
    const code = this.data?.CompanyInfoVungTrongDetail?.Code || this.CompanyInfoVungTrongService.FormData?.Code || "";
    this.HistoryService.BaseParameter.SearchString = code;
    this.HistoryService.GetBySearchStringToListAsync().subscribe(
      res => {
        this.HistoryService.List = (res as History[]).sort((a, b) => (a.LastUpdatedDate < b.LastUpdatedDate ? 1 : -1));
        this.HistoryService.DataSource = new MatTableDataSource(this.HistoryService.List);
        this.HistoryService.DataSource.sort = this.HistorySort002;
        this.HistoryService.DataSource.paginator = this.HistoryPaginator002;
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
    
  }
  TimKiemMatHangXuatKhau(){
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    // this.data.CompanyInfoVungTrongDetail
    if(this.data.CompanyInfoVungTrongDetail != undefined)
      this.MatHangXuatKhauService.BaseParameter.SearchString = this.data.CompanyInfoVungTrongDetail.Code;
    else
      this.MatHangXuatKhauService.BaseParameter.SearchString = "";
    this.MatHangXuatKhauService.GetBySearchStringAndEmptyToListAsync().subscribe(
      res => {
        this.MatHangXuatKhauService.List = (res as MatHangXuatKhau[]).sort((a, b) => (a.SortOrder < b.SortOrder ? 1 : -1));
        let idZeroItem = this.MatHangXuatKhauService.List.filter(p => p.ID === 0);
        idZeroItem.forEach(element => {
          element.HienTrangID = 2;
        });
        const otherItems = this.MatHangXuatKhauService.List.filter(p => p.ID !== 0);
        this.MatHangXuatKhauService.List = [...idZeroItem, ...otherItems];
        this.MatHangXuatKhauService.DataSource = new MatTableDataSource(this.MatHangXuatKhauService.List);
        this.MatHangXuatKhauService.DataSource.sort = this.CompanyInfoVungTrongDocumentsSort002;
        this.MatHangXuatKhauService.DataSource.paginator = this.CompanyInfoVungTrongDocumentsPaginator002;
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
    
  }
  MatHangXuatKhauSave(element:MatHangXuatKhau){
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    element.ParentID = this.CompanyInfoVungTrongService.FormData.ID;
    element.Code = this.CompanyInfoVungTrongService.FormData.Code;
    this.MatHangXuatKhauService.FormData = element;
    this.MatHangXuatKhauService.SaveAsync().subscribe(
      res => {
        this.TimKiemMatHangXuatKhau();
        this.NotificationService.warn(environment.SaveSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }
  templateStaffList:string[]
  SetDataToCompanyInfo(){
    if(this.countResultSetting==2){
      if(this.data.ID>0){
        // this.CompanyInfoVungTrongService.FormData.CompanyInfoID = 0
        const exist = this.CompanyInfoService.List.find(c=>c.ID == this.CompanyInfoVungTrongService.FormData.CompanyInfoID);
        this.CompanyInfoVungTrongService.FormData.Code = this.data.CompanyInfoVungTrongDetail.Code
        if(!exist){
          this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
          this.CompanyInfoService.BaseParameter.ID = this.data.CompanyInfoVungTrongDetail.CompanyInfoID;
          this.CompanyInfoService.GetByIDAsync().subscribe(
            res => {
              this.CompanyInfoService.FormData = res as CompanyInfo;
              this.CompanyInfoService.List.push(this.CompanyInfoService.FormData);
              this.CompanyInfoVungTrongService.FormData.DistrictDataID = this.data.CompanyInfoVungTrongDetail.DistrictDataID;
              this.WardDataSearch(true);

              this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
            },
            err => {
              this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
            }
          );
        }else{
          this.CompanyInfoVungTrongService.FormData = this.data.CompanyInfoVungTrongDetail;
        }
      }else{
        if(!this.data.IsStaff){
          this.CompanyInfoVungTrongService.FormData.CompanyInfoID = this.ThanhVienService.FormDataLogin.CompanyInfoID
          this.CompanyInfoChange()
        }
        this.CompanyInfoVungTrongService.FormData.DanhMucATTPTinhTrangID = 12
        this.CompanyInfoVungTrongService.FormData.DanhMucATTPTinhTrangName = "Bản Nháp"
        this.CompanyInfoVungTrongService.FormData.DanhMucATTPXepLoaiID = 5
        this.CompanyInfoVungTrongService.FormData.DanhMucATTPXepLoaiName = "Chưa thẩm định"
      }
      this.CompanyInfoVungTrongToaDoSearch();
      this.CompanyInfoDonViDongGoiNongHoSearch();
      this.CompanyInfoVungTrongDocumentsSearch();
      this.CompanyInfoVungTrongService.FormData.ProvinceDataID = environment.ProvinceDataIDBenTre;
      this.CompanyInfoVungTrongService.FormData.ProvinceDataName = 'Tỉnh Bến Tre';
    }
    else
      this.countResultSetting++;
  }
  CheckTemplateOfStaff(element:CompanyInfoVungTrongDocuments){
    if(this.templateStaffList.find(t=>t == element.Name))
    {
      if(this.IsStaff){
        return true
      }
    }else
      return true
    return false
  }
  DateNgayGhiNhan(value) {
    this.CompanyInfoVungTrongService.FormData.NgayGhiNhan = new Date(value);
  }
  DateThongBaoLaiKiemTraGiamSat(value) {
    this.CompanyInfoVungTrongService.FormData.NgayThongBaoLaiKiemTraGiamSat = new Date(value);
  }
  CompanyInfoVungTrongDocumentsNgayGhiNhan(element: CompanyInfoVungTrongDocuments, value) {
    element.NgayGhiNhan = new Date(value);
  }
  ThanhVienGetLogin() {
    this.ThanhVienService.GetLogin();
  }
  CompanyInfoChange() {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    this.CompanyInfoService.BaseParameter.ID = this.CompanyInfoVungTrongService.FormData.CompanyInfoID;
    this.CompanyInfoService.GetByIDAsync().subscribe(
      res => {
        this.CompanyInfoService.FormData = res as CompanyInfo;
        this.CompanyInfoVungTrongService.FormData.CompanyInfoID = this.CompanyInfoService.FormData.ID;
        this.CompanyInfoVungTrongService.FormData.CompanyInfoName = this.CompanyInfoService.FormData.Name;
        this.CompanyInfoVungTrongService.FormData.DaiDienCoSo = this.CompanyInfoService.FormData.fullname;
        this.CompanyInfoVungTrongService.FormData.DaiDienCoSoChucVu = this.CompanyInfoService.FormData.role_name;
        this.CompanyInfoVungTrongService.FormData.DaiDienCoSoDienThoai = this.CompanyInfoService.FormData.phone;
        this.CompanyInfoVungTrongService.FormData.DaiDienCoSoEmail = this.CompanyInfoService.FormData.email;
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }

  CompanyInfoSearch() {
    this.CompanyInfoService.ComponentGet000ToListAsync();
    setTimeout(() => this.CompanyInfoDeduplicate(), 200);
  }
  CompanyInfoFilter(searchString: string) {
    this.CompanyInfoService.Filter000(searchString);
  }
  uniqueByName<T extends { ID?: number, Name?: string }>(items: T[]): T[] {
    const seen = new Map<string, T>();
    for (const item of items || []) {
      const name = (item.Name || '').trim();
      if (!name) continue;
      const key = name.toLowerCase();
      if (!seen.has(key) || (item.ID || 0) < (seen.get(key)?.ID || 0)) {
        seen.set(key, item);
      }
    }
    return Array.from(seen.values());
  }
  CompanyInfoDeduplicate(){
    if(!this.CompanyInfoService.List) return;
    const result = this.uniqueByName(this.CompanyInfoService.List);
    this.CompanyInfoService.List = result;
    this.CompanyInfoService.ListFilter = result;
  }
  countResultSetting:number=0
  async DanhMucATTPTinhTrangSearch(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.DanhMucATTPTinhTrangService.ComponentGetAllToListAsyncUpdate().subscribe(
        res => {
          this.DanhMucATTPTinhTrangService.List = this.uniqueByName(res as DanhMucATTPTinhTrang[]);
          this.DanhMucATTPTinhTrangService.ListFilter = this.DanhMucATTPTinhTrangService.List;
          this.SetDataToCompanyInfo()
          // if(this.countResultSetting==2)
          //   this.SetDataToCompanyInfo()
          // else
          //   this.countResultSetting++;
          // this.CompanyInfoVungTrongService.FormData.DanhMucATTPTinhTrangID = this.data.CompanyInfoVungTrongDetail.DanhMucATTPTinhTrangID;
          resolve();
        },
        err => {
          reject(err);
        }
      );
    });
  }

  FindbyExist(idInpupt:number,type:number){
    const safeName = (list:any[], id:number)=> {
      if(!list) return "";
      const item = list.find(l=>l.ID == id);
      return (item?.Name || "").trim();
    }
    if(type==1)
    {
      const name = safeName(this.DanhMucATTPLoaiHoSoService.List, idInpupt);
      if(environment.HienThiLyDo.find(element =>element == name)) return true;
    }
    if(type == 2)
    {
      const name = safeName(this.DanhMucATTPTinhTrangService.List, idInpupt);
      if(environment.HienThiLyDo.find(element =>element == name)) return true;
    }
    if(type == 3)
    {
      const name = safeName(this.DanhMucATTPXepLoaiService.List, idInpupt);
      if(environment.HienThiLyDo.find(element =>element == name)) return true;
    }
    return false
    // return this.DanhMucATTPLoaiHoSoService.List.find(l=>l.ID == idInpupt).Name;
  }
  IsShowDVTC:boolean = true
  IsShowLyDoCSDG:boolean = false
  IsShowLyDoVT:boolean = false
  FindTinhTrangHoSoNameByID(idInput:number){
    if(idInput == null || idInput == undefined) return "";
    return this.TinhTrangHoSoService.List.find(l=>l.ID == idInput)?.Name;
  }
  FindTinhTrangTDKTGSNameByID(idInput:number){
    if(idInput == null || idInput == undefined) return "";
    return this.TinhTrangTDKTGSService.List.find(l=>l.ID == idInput)?.Name;
  }
  ChangeLyDoCSDG(){
    this.IsShowLyDoCSDG = false;
    if(this.CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID == 1 || this.CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID == null) return;
    this.IsShowLyDoCSDG = true;
  }
  ChangeLyDoHS(){
    this.IsShowLyDoVT = false;
    if(this.CompanyInfoVungTrongService.FormData.TinhTrangHoSoID == 1 || this.CompanyInfoVungTrongService.FormData.TinhTrangHoSoID == null) return;
    this.IsShowLyDoVT = true;
  }
  ATTPLoaiHoSoChange(){
    const result = this.FindbyExist(this.CompanyInfoVungTrongService.FormData.DanhMucATTPLoaiHoSoID, 1);
    // const result = danhMucATTPLoaiHoSoName != environment.DangKyChuyenChuThe;
    if(!result) this.IsShowDVTC = true;
    else this.IsShowDVTC = false;
    if(result && !this.IsStaff){
      this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
      this.CompanyInfoVungTrongService.FormData.CompanyInfoID = this.ThanhVienService.FormDataLogin.CompanyInfoID;

      this.CompanyInfoChange();
      this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
    }
  }
  // DanhMucATTPTinhTrangSearch() {
  //   this.DanhMucATTPTinhTrangService.ComponentGetAllToListAsync();
  // }

  DanhMucATTPLoaiHoSoSearch() {
    this.DanhMucATTPLoaiHoSoService.GetAllToListAsync().subscribe(
      res =>{
        this.SetDataToCompanyInfo()
        this.DanhMucATTPLoaiHoSoService.List = this.uniqueByName(res as DanhMucATTPLoaiHoSo[]);
        this.DanhMucATTPLoaiHoSoService.ListFilter = this.DanhMucATTPLoaiHoSoService.List;
      },
      err=>{

      }
    );
    // this.DanhMucATTPLoaiHoSoService.ComponentGetAllToListAsync();
  }

  DanhMucATTPXepLoaiSearch() {
    this.DanhMucATTPXepLoaiService.ComponentGetAllToListAsync();
    setTimeout(()=>{
      if(this.DanhMucATTPXepLoaiService.List){
        this.DanhMucATTPXepLoaiService.List = this.uniqueByName(this.DanhMucATTPXepLoaiService.List);
        this.DanhMucATTPXepLoaiService.ListFilter = this.DanhMucATTPXepLoaiService.List;
      }
    },200);
  }

  openFileInput2(element: any) {
    const index = this.CompanyInfoDonViDongGoiDocumentsService.List.indexOf(element); // Tìm index của element
    if (index !== -1) {
      const inputElement = this.fileInputs.toArray()[index];
      inputElement.nativeElement.click();
    }
  }

  openFileInput3(element: any) {
    const index = this.MatHangXuatKhauService.List.indexOf(element); // Tìm index của element
    if (index !== -1) {
      const inputElement = this.fileInputs3.toArray()[index];
      inputElement.nativeElement.click();
    }
  }
  openFileInput4(element: any) {
    const index = this.MatHangXuatKhauService.List.indexOf(element); // Tìm index của element
    if (index !== -1) {
      const inputElement = this.fileInputs4.toArray()[index];
      inputElement.nativeElement.click();
    }
  }
  
  isPDFFile(fileName: string): boolean {
    return /\.pdf$/i.test(fileName);
  }
  isWordFile(fileName: string): boolean {
    return /\.(doc|docx)$/i.test(fileName);
  }
  isExcelFile(fileName: string): boolean {
    return /\.(xlsx|xls)$/i.test(fileName);
  }
  isWordOrExcelFile(fileName: string): boolean {
    return /\.(doc|docx|xlsx)$/i.test(fileName);
  }
  isHtmlFile(fileName: string): boolean {
    return /\.(html)$/i.test(fileName);
  }
  
  changeExtensionToPdf(url: string): string {
    try {
      const urlObj = new URL(url); // parse url
      const path = urlObj.pathname; // lấy phần path
      
      // tách tên file
      const lastDotIndex = path.lastIndexOf(".");
      if (lastDotIndex !== -1) {
        const ext = path.substring(lastDotIndex + 1).toLowerCase();
        if (ext !== "pdf") {
          urlObj.pathname = path.substring(0, lastDotIndex) + ".pdf";
        }
      } else {
        // nếu không có extension thì thêm luôn .pdf
        urlObj.pathname = path + ".pdf";
      }
      return urlObj.toString();
    } catch {
      // nếu url không hợp lệ thì xử lý chuỗi bình thường
      if (url.includes(".")) {
        return url.replace(/\.[^/.]+$/, ".pdf");
      }
      return url + ".pdf";
    }
  }
  getViewerUrl(fileName: string): string {
    if (this.isPDFFile(fileName) || this.isHtmlFile(fileName)) {
      return fileName;
    }else{
      return this.changeExtensionToPdf(fileName);
    }
    
  }

  DistrictDataSearch() {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    this.DistrictDataService.BaseParameter.ParentID = environment.ProvinceDataIDBenTre;
    let setDistrict = false;
    this.DistrictDataService.GetByParentIDToListAsync().subscribe(
      res => {
        this.DistrictDataService.List = (res as DistrictData[]).sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));
        if (this.DistrictDataService.List) {
          if (this.DistrictDataService.List.length > 0) {
            if (this.CompanyInfoVungTrongService.FormData.ID == 0) {
              this.CompanyInfoVungTrongService.FormData.DistrictDataID = this.DistrictDataService.List[0].ID;
            }
          }
        }
        this.SetDataToCompanyInfo()
        // Tự động nạp danh sách xã khi đã có huyện mặc định
        if (this.CompanyInfoVungTrongService.FormData.DistrictDataID) {
          this.WardDataSearch(this.data.ID > 0);
        }
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }

  WardDataSearch(IsSetData :boolean = false) {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    
    if(this.CompanyInfoVungTrongService != undefined && this.CompanyInfoVungTrongService.FormData.DistrictDataID != null)
      this.WardDataService.BaseParameter.ParentID = this.CompanyInfoVungTrongService.FormData.DistrictDataID;
    else
      this.WardDataService.BaseParameter.ParentID = 0;
    this.WardDataService.GetByParentIDToListAsync().subscribe(
      res => {
        this.WardDataService.List = (res as WardData[]).sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));
        if(IsSetData) 
          this.CompanyInfoVungTrongService.FormData = this.data.CompanyInfoVungTrongDetail;
        // Nếu chưa có xã được chọn, chọn mặc định bản ghi đầu tiên
        if(!IsSetData && !this.CompanyInfoVungTrongService.FormData.WardDataID && this.WardDataService.List.length>0){
          this.CompanyInfoVungTrongService.FormData.WardDataID = this.WardDataService.List[0].ID;
        }
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }
  DanhMucThiTruongChange() {
    if (this.CompanyInfoVungTrongService.FormData.ThiTruong) {
      this.CompanyInfoVungTrongService.FormData.ThiTruong = this.CompanyInfoVungTrongService.FormData.ThiTruong + "; " + this.CompanyInfoVungTrongService.FormData.Display;
    }
    else {
      this.CompanyInfoVungTrongService.FormData.ThiTruong = this.CompanyInfoVungTrongService.FormData.Display;
    }
  }

  ProductGroupSearch() {
    this.ProductGroupService.ComponentGetAllToListAsync();
  }

  TinhTrangHoSoSearch() {
    this.TinhTrangHoSoService.ComponentGetAllToListAsync();
  }
  TinhTrangTDKTGSSearch() {
    this.TinhTrangTDKTGSService.ComponentGetAllToListAsync();
  }

  DanhMucThiTruongSearch() {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    this.DanhMucThiTruongService.GetAllToListAsync().subscribe(
      res => {
        this.DanhMucThiTruongService.List = (res as DanhMucThiTruong[]).sort((a, b) => (a.Name > b.Name ? 1 : -1)).filter(d=>d?.Name?.trim()!="" && d?.Name != null);
        this.DanhMucThiTruongService.ListFilter = this.DanhMucThiTruongService.List;
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }


  CompanyInfoVungTrongToaDoSearch() {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    this.CompanyInfoVungTrongToaDoService.BaseParameter.SearchString = this.CompanyInfoVungTrongService.FormData.Code;
    this.CompanyInfoVungTrongToaDoService.GetBySearchStringToListAsync().subscribe(
      res => {
        this.CompanyInfoVungTrongToaDoService.List = (res as CompanyInfoVungTrongToaDo[]).sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));
        this.CompanyInfoVungTrongToaDoService.DataSource = new MatTableDataSource(this.CompanyInfoVungTrongToaDoService.List);
        this.CompanyInfoVungTrongToaDoService.DataSource.sort = this.CompanyInfoVungTrongToaDoSort;
        this.CompanyInfoVungTrongToaDoService.DataSource.paginator = this.CompanyInfoVungTrongToaDoPaginator;
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }
  CompanyInfoVungTrongToaDoSave(element: CompanyInfoVungTrongToaDo) {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    element.ParentID = this.CompanyInfoVungTrongService.FormData.ID;
    element.Code = this.CompanyInfoVungTrongService.FormData.Code;
    this.CompanyInfoVungTrongToaDoService.FormData = element;
    this.CompanyInfoVungTrongToaDoService.SaveAsync().subscribe(
      res => {
        this.CompanyInfoVungTrongToaDoSearch();
        this.NotificationService.warn(environment.SaveSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }
  CompanyInfoVungTrongDocumentsDownload() {
    for (let i = 0; i < this.CompanyInfoDonViDongGoiDocumentsService.List.length; i++) {
      let CompanyInfoVungTrongDocuments = this.CompanyInfoDonViDongGoiDocumentsService.List[i];
      if (CompanyInfoVungTrongDocuments.FileName) {
        if (CompanyInfoVungTrongDocuments.FileName.length > 0) {          
          const url = CompanyInfoVungTrongDocuments.FileName.replace('bentre.gov.vn', 'vinhlong.gov.vn');
          window.open(url, "_blank");
        }
      }
    }
  }
  
  ChangeFileName2(element: CompanyInfoVungTrongDocuments, files: FileList | null) {
    if (files && files.length > 0) {
      this.CompanyInfoDonViDongGoiDocumentsService.FileToUpload = files;
      this.PlanThamDinhCompanyDocumentsSave1(element)
    }
  }

  CompanyInfoVungTrongDocumentsSearch() {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    this.CompanyInfoDonViDongGoiDocumentsService.BaseParameter.SearchString = this.CompanyInfoVungTrongService.FormData.Code;
    this.CompanyInfoDonViDongGoiDocumentsService.GetBySearchStringAndEmptyToListAsync().subscribe(
      res => {
        this.CompanyInfoDonViDongGoiDocumentsService.List = (res as CompanyInfoVungTrongDocuments[]).sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));

        this.GiamSatFile = this.CompanyInfoDonViDongGoiDocumentsService.List.find(c=>c.DocumentTemplateID == 422112);
        this.GiamSatFile1 = this.CompanyInfoDonViDongGoiDocumentsService.List.find(c=>c.DocumentTemplateID == 422113);
        this.GiamSatFile2 = this.CompanyInfoDonViDongGoiDocumentsService.List.find(c=>c.DocumentTemplateID == 422114);
        this.GiamSatFile3 = this.CompanyInfoDonViDongGoiDocumentsService.List.find(c=>c.DocumentTemplateID == 422115);
        this.GiamSatFile4 = this.CompanyInfoDonViDongGoiDocumentsService.List.find(c=>c.DocumentTemplateID == 422116);
        
        this.CompanyInfoDonViDongGoiDocumentsService.DataSource = new MatTableDataSource(
          this.CompanyInfoDonViDongGoiDocumentsService.List.filter(x => x.IsPheDuyet != true && x.Note == null)
        );
        this.CompanyInfoDonViDongGoiDocumentsService.DataSource.sort = this.CompanyInfoVungTrongDocumentsSort;
        this.CompanyInfoDonViDongGoiDocumentsService.DataSource.paginator = this.CompanyInfoVungTrongDocumentsPaginator;

        this.CompanyInfoDonViDongGoiDocumentsService.DataSource002 = new MatTableDataSource(
          this.CompanyInfoDonViDongGoiDocumentsService.List.filter(x => x.IsPheDuyet == true || x.ID == 0)
        );
        this.CompanyInfoDonViDongGoiDocumentsService.DataSource002.sort = this.CompanyInfoVungTrongDocumentsSort002;
        this.CompanyInfoDonViDongGoiDocumentsService.DataSource002.paginator = this.CompanyInfoVungTrongDocumentsPaginator002;
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }
  UpdateThamDinh(){
    this.CompanyInfoVungTrongService.FormData.LastUpdatedDate = new Date();
    this.CompanyInfoVungTrongSave(false,true);
  }
  CompanyInfoVungTrongDocumentsSave(element: CompanyInfoVungTrongDocuments) {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    element.ParentID = this.CompanyInfoVungTrongService.FormData.ID;
    element.Code = this.CompanyInfoVungTrongService.FormData.Code;
    this.CompanyInfoDonViDongGoiDocumentsService.FormData = element;
    this.CompanyInfoDonViDongGoiDocumentsService.SaveAndUploadFileAsync().subscribe(
      res => {
        this.CompanyInfoDonViDongGoiDocumentsService.FormData = (res as CompanyInfoVungTrongDocuments);
        this.CompanyInfoVungTrongDocumentsSearch();
        this.NotificationService.warn(environment.SaveSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }
  private SetTinhTrangHoSoHoanThien(){
    const list = this.DanhMucATTPTinhTrangService.List || [];
    const ttHoanThien = list.find(x => (x.Name || '').trim().toLowerCase() === 'hồ sơ hoàn thiện')
      || list.find(x => (x.Name || '').trim().toLowerCase() === 'đã hoàn thành')
      || list.find(x => (x.Name || '').toLowerCase().includes('hồ sơ hoàn thiện'))
      || list.find(x => (x.Name || '').toLowerCase().includes('hoàn thành'));
    if(ttHoanThien){
      this.CompanyInfoVungTrongService.FormData.DanhMucATTPTinhTrangID = ttHoanThien.ID;
      this.CompanyInfoVungTrongService.FormData.DanhMucATTPTinhTrangName = ttHoanThien.Name;
      // giữ TinhTrangHoSoID null để hiển thị tên trạng thái hồ sơ tại danh sách
      this.CompanyInfoVungTrongService.FormData.TinhTrangHoSoID = null;
    }else{
      // fallback: chỉ gán name nếu chưa có item phù hợp
      this.CompanyInfoVungTrongService.FormData.DanhMucATTPTinhTrangName = 'Hồ sơ hoàn thiện';
      this.CompanyInfoVungTrongService.FormData.TinhTrangHoSoID = null;
    }
  }
  KetThucHoSo(){
    this.CompanyInfoVungTrongService.FormData.status_id = 1;
    this.SetTinhTrangHoSoHoanThien();
    this.CompanyInfoVungTrongSave(false,true);
  }

  ChangeFileName3(element:MatHangXuatKhau, files: FileList | null) {
    if (files && files.length > 0) {
      this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
      this.MatHangXuatKhauService.FileToUpload = files;
      this.MatHangXuatKhauService.BaseParameter.SearchString = this.CompanyInfoVungTrongService.FormData.Code;
      this.PlanThamDinhCompanyDocumentsSave2(element)
    }
  }
  ChangeFileName4(element:MatHangXuatKhau, files: FileList | null) {
    if (files && files.length > 0) {
      this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
      this.MatHangXuatKhauService.FileToUpload = files;
      this.PlanThamDinhCompanyDocumentsSave3(element)
    }
  }
  PlanThamDinhCompanyDocumentsSave2(matHangXuatKhau: MatHangXuatKhau) {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    matHangXuatKhau.ParentID = this.CompanyInfoVungTrongService.FormData.ID;
    matHangXuatKhau.Code = this.CompanyInfoVungTrongService.FormData.Code;
    this.MatHangXuatKhauService.FormData = matHangXuatKhau;
    this.MatHangXuatKhauService.SaveAndUploadFileAsync().subscribe(
      res => {
        // let changeData = this.MatHangXuatKhauService.List.find(m=>m.IDTemp = matHangXuatKhau.IDTemp);
        // changeData.FileName = (res as MatHangXuatKhau)
        matHangXuatKhau.FileName = (res as MatHangXuatKhau).FileName;
        // this.TimKiemMatHangXuatKhau();
        this.NotificationService.warn(environment.SaveSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.UploadNotSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }
  PlanThamDinhCompanyDocumentsSave3(matHangXuatKhau: MatHangXuatKhau) {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    matHangXuatKhau.ParentID = this.CompanyInfoVungTrongService.FormData.ID;
    matHangXuatKhau.Code = this.CompanyInfoVungTrongService.FormData.Code;
    this.MatHangXuatKhauService.FormData = matHangXuatKhau;
    if (this.MatHangXuatKhauService.FileToUpload && this.MatHangXuatKhauService.FileToUpload.length > 0) {
      matHangXuatKhau.FileDinhKem = this.MatHangXuatKhauService.FileToUpload[0].name;
    }
    this.MatHangXuatKhauService.SaveAsync().subscribe(
      res => {
        this.TimKiemMatHangXuatKhau();
        this.NotificationService.warn(environment.SaveSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }
  PlanThamDinhCompanyDocumentsSave1(CompanyInfoVungTrongDocument: CompanyInfoVungTrongDocuments) {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    CompanyInfoVungTrongDocument.ParentID = this.CompanyInfoVungTrongService.FormData.ID;
    CompanyInfoVungTrongDocument.Code = this.CompanyInfoVungTrongService.FormData.Code;
    this.CompanyInfoDonViDongGoiDocumentsService.FormData = CompanyInfoVungTrongDocument;
    this.CompanyInfoDonViDongGoiDocumentsService.SaveAndUploadFileAsync().subscribe(
      res => {
        this.CompanyInfoVungTrongDocumentsSearch();
        this.NotificationService.warn(environment.SaveSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }
  CompanyInfoVungTrongDocumentsSave002(element: CompanyInfoVungTrongDocuments) {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    element.ParentID = this.CompanyInfoVungTrongService.FormData.ID;
    element.Code = this.CompanyInfoVungTrongService.FormData.Code;
    element.IsPheDuyet = true;
    this.CompanyInfoDonViDongGoiDocumentsService.FormData = element;
    this.CompanyInfoDonViDongGoiDocumentsService.SaveAndUploadFileAsync().subscribe(
      res => {
        this.CompanyInfoDonViDongGoiDocumentsService.FormData = (res as CompanyInfoVungTrongDocuments);
        this.CompanyInfoVungTrongDocumentsSearch();
        this.NotificationService.warn(environment.SaveSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }
  CompanyInfoVungTrongDocumentsDelete(element: CompanyInfoVungTrongDocuments) {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    this.CompanyInfoDonViDongGoiDocumentsService.BaseParameter.ID = element.ID;
    this.CompanyInfoDonViDongGoiDocumentsService.RemoveAsync().subscribe(
      res => {
        this.CompanyInfoVungTrongDocumentsSearch();
        this.NotificationService.warn(environment.SaveSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }

  CompanyInfoVungTrongDocumentsAdd(element: CompanyInfoVungTrongDocuments) {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    this.CompanyInfoDonViDongGoiDocumentsService.BaseParameter.ID = element.ID;
    this.CompanyInfoDonViDongGoiDocumentsService.GetByIDAsync().subscribe(
      res => {
        this.CompanyInfoDonViDongGoiDocumentsService.FormData = res as CompanyInfoVungTrongDocuments;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = environment.DialogConfigWidth;
        dialogConfig.data = { ID: this.CompanyInfoDonViDongGoiDocumentsService.FormData.ID };
        const dialog = this.dialog.open(CompanyInfoVungTrongDocumentsDetailComponent, dialogConfig);
        dialog.afterClosed().subscribe(() => {
        });
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }

  // SubmitCompanyInfo() {
  //   this.UploadService.IsShowLoading = true;
  //   this.UploadService.File = this.uploadCompanyInfo.nativeElement.files[0];
  //   this.UploadService.PostCompanyInfo_CompanyInfoLichSuKiemTraByExcelFileAsync().subscribe(
  //     res => {
  //       this.UploadService.IsShowLoading = false;
  //       this.NotificationService.warn(environment.UploadSuccess);
  //     },
  //     err => {
  //       this.UploadService.IsShowLoading = false;
  //       this.NotificationService.warn(environment.UploadNotSuccess);
  //     }
  //   );
  // }
  
  GiamSatFile1: PlanThamDinhCompanyDocument
  GiamSatFile2: PlanThamDinhCompanyDocument
  GiamSatFile: PlanThamDinhCompanyDocument
  GiamSatFile3: PlanThamDinhCompanyDocument
  GiamSatFile4: PlanThamDinhCompanyDocument
  UploadFileGiamSat(){
    this.uploadGiamSatDuLuong.nativeElement.click();
  }
  UploadFileGiamSat1(){
    this.uploadGiamSatDuLuong1.nativeElement.click();
  }
  UploadFileGiamSat2(){
    this.uploadGiamSatDuLuong2.nativeElement.click();
  }
  UploadFileGiamSat3(){
    this.uploadGiamSatDuLuong3.nativeElement.click();
  }
  UploadFileGiamSat4(){
    this.uploadGiamSatDuLuong4.nativeElement.click();
  }
  ChangeNhuyenThe02ManhVo1(files: FileList) {
    if (files && files.length > 0) {
      this.NotificationService.warn(environment.UploadSuccess);
      let uploadNongHo:CompanyInfoVungTrongDocuments  = {};
      uploadNongHo.DocumentTemplateID = 422113
      this.CompanyInfoDonViDongGoiDocumentsService.FileToUpload = files;
      uploadNongHo.Note = "FileUpload";
      this.PlanThamDinhCompanyDocumentsSave1(uploadNongHo);
    }
  }
  ChangeNhuyenThe02ManhVo2(files: FileList) {
    if (files && files.length > 0) {
      this.NotificationService.warn(environment.UploadSuccess);
      let uploadNongHo:CompanyInfoVungTrongDocuments  = {};
      uploadNongHo.DocumentTemplateID = 422114
      this.CompanyInfoDonViDongGoiDocumentsService.FileToUpload = files;
      uploadNongHo.Note = "FileUpload";
      this.PlanThamDinhCompanyDocumentsSave1(uploadNongHo);
    }
  }
  ChangeNhuyenThe02ManhVo3(files: FileList) {
    if (files && files.length > 0) {
      this.NotificationService.warn(environment.UploadSuccess);
      let uploadNongHo:CompanyInfoVungTrongDocuments  = {};
      uploadNongHo.DocumentTemplateID = 422115
      this.CompanyInfoDonViDongGoiDocumentsService.FileToUpload = files;
      uploadNongHo.Note = "FileUpload";
      this.PlanThamDinhCompanyDocumentsSave1(uploadNongHo);
    }
  }
  ChangeNhuyenThe02ManhVo4(files: FileList) {
    if (files && files.length > 0) {
      this.NotificationService.warn(environment.UploadSuccess);
      let uploadNongHo:CompanyInfoVungTrongDocuments  = {};
      uploadNongHo.DocumentTemplateID = 422116
      this.CompanyInfoDonViDongGoiDocumentsService.FileToUpload = files;
      uploadNongHo.Note = "FileUpload";
      this.PlanThamDinhCompanyDocumentsSave1(uploadNongHo);
    }
  }
  
  ChangeNhuyenThe02ManhVo(files: FileList) {
    if (files && files.length > 0) {
      this.NotificationService.warn(environment.UploadSuccess);
      let uploadNongHo:CompanyInfoVungTrongDocuments  = {};
      uploadNongHo.DocumentTemplateID = 422112
      this.CompanyInfoDonViDongGoiDocumentsService.FileToUpload = files;
      uploadNongHo.Note = "FileUpload";
      this.PlanThamDinhCompanyDocumentsSave1(uploadNongHo);
    }
  }
  SHOWRESULT :boolean = environment.ShowResult
  PlanThamDinhCompanyDocumentsSave(documentTemplateID) {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    let element: PlanThamDinhCompanyDocument = new PlanThamDinhCompanyDocument()
    element.DocumentTemplateID = documentTemplateID;
    // element.IsUploadConfirm = this.SHOWRESULT;
    // element.PlanThamDinhID = this.PlanThamDinhService.FormData.ID;
    // element.Code = this.PlanThamDinhService.FormData.Code;
    // element.PlanTypeID = environment.PlanTypeIDCoSoNuoi
    // this.PlanThamDinhCompanyDocumentService.FormData = element;
    this.PlanThamDinhCompanyDocumentService.SaveAndUploadFileAsync().subscribe(
      res => {
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }
  ChangeFileName(element: CompanyInfoVungTrongDocuments, files: FileList) {
    if (files) {
      this.CompanyInfoDonViDongGoiDocumentsService.FileToUpload = files;
      //this.CompanyInfoVungTrongDocumentsSave(element);
    }
  }


  CompanyInfoDonViDongGoiNongHoSearch() {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    this.CompanyInfoDonViDongGoiNongHoService.BaseParameter.SearchString = this.CompanyInfoVungTrongService.FormData.Code;
    this.CompanyInfoDonViDongGoiNongHoService.GetBySearchStringAndEmptyToListAsync().subscribe(
      res => {
        this.CompanyInfoDonViDongGoiNongHoService.List = (res as CompanyInfoDonViDongGoiNongHo[]).sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));
        const idZeroItem = this.CompanyInfoDonViDongGoiNongHoService.List.filter(p => p.ID === 0);
        const otherItems = this.CompanyInfoDonViDongGoiNongHoService.List.filter(p => p.ID !== 0);
        this.CompanyInfoDonViDongGoiNongHoService.List = [...idZeroItem, ...otherItems];
        this.CompanyInfoDonViDongGoiNongHoService.DataSource = new MatTableDataSource(this.CompanyInfoDonViDongGoiNongHoService.List);
        this.CompanyInfoDonViDongGoiNongHoService.DataSource.sort = this.CompanyInfoDonViDongGoiNongHoSort;
        this.CompanyInfoDonViDongGoiNongHoService.DataSource.paginator = this.CompanyInfoDonViDongGoiNongHoPaginator;
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }
  CompanyInfoDonViDongGoiNongHoSave(element: CompanyInfoDonViDongGoiNongHo) {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    element.ParentID = this.CompanyInfoVungTrongService.FormData.ID;
    element.Code = this.CompanyInfoVungTrongService.FormData.Code;
    this.CompanyInfoDonViDongGoiNongHoService.FormData = element;
    this.CompanyInfoDonViDongGoiNongHoService.SaveAsync().subscribe(
      res => {
        this.CompanyInfoDonViDongGoiNongHoSearch();
        this.NotificationService.warn(environment.SaveSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }
  CompanyInfoDonViDongGoiNongHoDelete(element: CompanyInfoDonViDongGoiNongHo) {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    this.CompanyInfoDonViDongGoiNongHoService.BaseParameter.ID = element.ID;
    this.CompanyInfoDonViDongGoiNongHoService.RemoveAsync().subscribe(
      res => {
        this.CompanyInfoDonViDongGoiNongHoSearch();
        this.NotificationService.warn(environment.SaveSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }
  CheckHSVT(){
    let myHistory:History = {}
    
    myHistory.Code = this.CompanyInfoVungTrongService.FormData.Code;
    myHistory.TinhTrangHS = this.CompanyInfoVungTrongService.FormData.DanhMucATTPTinhTrangName;
    myHistory.TinhTrangHoSoID = this.CompanyInfoVungTrongService.FormData.TinhTrangHoSoID;
    myHistory.LyDoHS = this.CompanyInfoVungTrongService.FormData.GhiChuNoiDungMSHS;
    myHistory.TepHS = this.GiamSatFile3?.FileName;
    
    if(this.IsShowLyDoVT){
      return myHistory;
    }
    myHistory.NgayThongBaoKiemTraGiamSat = this.CompanyInfoVungTrongService.FormData.NgayThongBaoLaiKiemTraGiamSat;
    myHistory.FileDinhKemThongBaoKiemTraGiamSat = this.GiamSatFile4?.FileName;
    myHistory.TinhTrangTDKTGSID = this.CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID;
    myHistory.LyDoVT = this.CompanyInfoVungTrongService.FormData.NguyenNhanKhongDatVT;
    myHistory.TepVT = this.GiamSatFile1?.FileName;

    return myHistory;
  }
  CompanyInfoVungTrongSave(IsSentRequestToManger:boolean = false,IsSaveHistory:boolean = false) {
    if(IsSentRequestToManger){
      this.CompanyInfoVungTrongService.FormData.DanhMucATTPTinhTrangID = 11;
      this.CompanyInfoVungTrongService.FormData.DanhMucATTPTinhTrangName = 'Đã gửi cơ quan quản lý';
      
      this.CompanyInfoVungTrongService.FormData.TinhTrangHoSoID = null
      if(!this.CompanyInfoVungTrongService.FormData.NgayGhiNhan){
        this.CompanyInfoVungTrongService.FormData.NgayGhiNhan = new Date();
      }
    }
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    this.CompanyInfoVungTrongService.FormData.ParentID = this.CompanyInfoVungTrongService.FormData.CompanyInfoID;
    this.CompanyInfoVungTrongService.FormData.PlanTypeID = environment.PlanTypeIDDangKyMaDongGoi;
    this.CompanyInfoVungTrongService.FormData.TypePlan = 2;
    this.CompanyInfoVungTrongService.SaveAsync().subscribe(
      res => {
        this.CompanyInfoVungTrongService.FormData = res as CompanyInfoVungTrong;
        if(IsSaveHistory){
          let myHistory:History = this.CheckHSVT();
          this.HistoryService.FormData = myHistory
          this.HistoryService.SaveAsync().subscribe(
            res =>{
              this.TimKiemLichSu()
              this.NotificationService.warn(environment.SaveSuccess);
              // this.NotificationService.warn(this.PlanThamDinhService.ComponentSaveForm());
              this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
            },
            err =>{
              this.NotificationService.warn(environment.SaveNotSuccess);
              this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
            }
          )
        }else{
          this.NotificationService.warn(environment.SaveSuccess);
          // this.NotificationService.warn(this.PlanThamDinhService.ComponentSaveForm());
          this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
        }
        //this.PlanThamDinhSave();
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }

  PlanThamDinhSave() {
    // Chặn save trên mobile
    if (this.NotificationService.blockMobileActionIfNeeded()) {
      return;
    }
    
    this.PlanThamDinhService.IsShowLoading = true;
    this.PlanThamDinhService.FormData.ParentID = environment.PlanTypeIDDangKyMaDongGoi;
    this.PlanThamDinhService.FormData.StateAgencyID = environment.StateAgencyIDChiCucBaoVeThucVat;
    this.PlanThamDinhService.SaveAsync().subscribe(
      res => {
        this.NotificationService.warn(environment.SaveSuccess);
        this.PlanThamDinhService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.PlanThamDinhService.IsShowLoading = false;
      }
    );
  }

  /*
  CompanyInfoVungTrongSave() {
    this.CompanyInfoVungTrongService.FormData.ParentID = this.ThanhVienService.FormDataLogin.CompanyInfoID;
    this.NotificationService.warn(this.CompanyInfoVungTrongService.ComponentSaveForm());
  }
  */

  PlanThamDinhCompanyDocumentAdd(DocumentTemplateID: number) {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    this.PlanThamDinhCompanyDocumentService.BaseParameter.PlanThamDinhID = this.CompanyInfoVungTrongService.FormData.ID;
    this.PlanThamDinhCompanyDocumentService.BaseParameter.DocumentTemplateID = DocumentTemplateID;
    this.PlanThamDinhCompanyDocumentService.GetByPlanThamDinhID_DocumentTemplateIDAsync().subscribe(
      res => {
        this.PlanThamDinhCompanyDocumentService.FormData = res as PlanThamDinhCompanyDocument;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = environment.DialogConfigWidth;
        dialogConfig.data = { ID: this.PlanThamDinhCompanyDocumentService.FormData.ID };
        const dialog = this.dialog.open(PlanThamDinhCompanyDocumentDetailComponent, dialogConfig);
        dialog.afterClosed().subscribe(() => {
        });
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }
  ThanhVienSearch() {
    this.ThanhVienService.BaseParameter.ParentID = environment.DanhMucThanhVienIDNhanVien;
    this.ThanhVienService.BaseParameter.Active = true;
    this.ThanhVienService.ComponentGetByParentIDToListAsync();
  }
  ThanhVienAdd(ID: number) {
    this.CompanyInfoDonViDongGoiService.IsShowLoading = true;
    this.ThanhVienService.BaseParameter.ID = ID;
    this.ThanhVienService.GetByIDAsync().subscribe(
      res => {
        this.ThanhVienService.FormData = res as ThanhVien;
        this.ThanhVienService.FormData.ParentID = environment.DanhMucThanhVienIDNhanVien;
        //this.ThanhVienService.FormData.PlanThamDinhID = this.PlanThamDinhService.FormData.ID;
        //this.ThanhVienService.FormData.PlanThamDinhCode = this.PlanThamDinhService.FormData.Code;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = environment.DialogConfigWidth;
        dialogConfig.data = { ID: ID };
        const dialog = this.dialog.open(ThanhVienDetail001Component, dialogConfig);
        dialog.afterClosed().subscribe(() => {
          this.ThanhVienSearch();
        });
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      },
      err => {
        this.CompanyInfoDonViDongGoiService.IsShowLoading = false;
      }
    );
  }

  Close() {
    this.dialogRef.close();
  }


  map: maplibregl.Map | undefined;

  @ViewChild('map')
  private mapContainer!: ElementRef<HTMLElement>;

  ngAfterViewInit() {
    //this.MapLoad();
  }


  ngOnDestroy() {
    this.map?.remove();
  }

  MapInitialization(longitude, latitude) {
    let zoom = 10;
    if ((latitude > 90) || (latitude == 0)) {
      latitude = environment.Latitude;
      longitude = environment.Longitude;
    }
    this.map = new maplibregl.Map({
      container: this.mapContainer.nativeElement,
      style: 'https://api.maptiler.com/maps/hybrid/style.json?key=' + environment.MaptilerAPIKey,
      center: [longitude, latitude],
      zoom: zoom,
      pitch: 45,
    });

    this.map.addControl(
      new maplibregl.NavigationControl({
        visualizePitch: true,
        showZoom: true,
        showCompass: true
      })
    );
    this.map.addControl(
      new maplibregl.FullscreenControl({
      })
    );
    this.map.on('load', () => {

      this.map.addSource("HoangSa", {
        "type": "image",
        "url": environment.DomainURL + "assets/image/HoangSa01.png",
        "coordinates": [
          [111.09665858054495, 17.432475898867523],
          [113.11720985517763, 17.38420482529338],
          [112.79285037220984, 15.643938718432054],
          [110.88537855035554, 15.672592116966598],
        ]
      });
      this.map.addLayer({
        "id": "HoangSa",
        "source": "HoangSa",
        "type": "raster",
        "paint": {
          "raster-opacity": 1
        }
      });

      this.map.addSource("TruongSa", {
        "type": "image",
        "url": environment.DomainURL + "assets/image/TruongSa01.png",
        "coordinates": [
          [112.32373278444106, 12.236103169381323],
          [117.4620551483049, 11.606334626304161],
          [115.59654957671216, 7.357025445897818],
          [110.62186805246108, 7.811210355974268],


        ]
      });
      this.map.addLayer({
        "id": "TruongSa",
        "source": "TruongSa",
        "type": "raster",
        "paint": {
          "raster-opacity": 1
        }
      });

    });
  }

  MapLoad() {

    document.getElementById("map").style.height = "500px";

    if (this.CompanyInfoVungTrongService.FormData) {
      let latitude = environment.Latitude;
      let longitude = environment.Longitude;
      if (Number(this.CompanyInfoVungTrongService.FormData.KinhDo) > 0) {
        if (Number(this.CompanyInfoVungTrongService.FormData.ViDo) > 0) {
          latitude = Number(this.CompanyInfoVungTrongService.FormData.ViDo);
          longitude = Number(this.CompanyInfoVungTrongService.FormData.KinhDo);
        }
      }
      this.MapInitialization(longitude, latitude);
      if (latitude <= 90) {
        let popupContent = "<div style='opacity: 0.8; background-color: transparent;'>";
        popupContent = popupContent + "<a style='text-align: center;' class='link-primary form-label' href='#'><h1>" + this.CompanyInfoVungTrongService.FormData.Name + " [" + this.CompanyInfoVungTrongService.FormData.ID + "]</h1></a>";
        popupContent = popupContent + "<div>Đơn vị: <b>" + this.CompanyInfoVungTrongService.FormData.Name + "</b></div>";
        popupContent = popupContent + "<div>Điện thoại: <b>" + this.CompanyInfoVungTrongService.FormData.DaiDienCoSoDienThoai + "</b></div>";
        popupContent = popupContent + "<div>Địa chỉ: <b>" + this.CompanyInfoVungTrongService.FormData.DiaChi + "</b></div>";
        popupContent = popupContent + "</div>";

        let popup = new maplibregl.Popup({ offset: 25 }).setHTML(popupContent)
          .setMaxWidth("600px");

        var el = document.createElement('div');
        el.style.backgroundImage = "url(" + environment.DomainURL + "assets/image/logo_30.png)";
        el.style.width = '30px';
        el.style.height = '30px';

        let marker = new maplibregl.Marker({ element: el })
          .setLngLat([longitude, latitude])
          .setPopup(popup)
          .addTo(this.map);
      }

      if (this.CompanyInfoVungTrongToaDoService.List) {
        if (this.CompanyInfoVungTrongToaDoService.List.length > 0) {
          let listPolygon = [];
          let listToaDoPolygon = [];
          for (let i = 0; i < this.CompanyInfoVungTrongToaDoService.List.length; i++) {
            let CompanyInfoVungTrongToaDo = this.CompanyInfoVungTrongToaDoService.List[i];
            if (CompanyInfoVungTrongToaDo.IsTrungTam == true) {
              var el = document.createElement('div');
              el.style.backgroundColor = "green";
              el.style.width = '10px';
              el.style.height = '10px';

              let marker = new maplibregl.Marker({ element: el })
                .setLngLat([Number(CompanyInfoVungTrongToaDo.KinhDo), Number(CompanyInfoVungTrongToaDo.ViDo)])
                .addTo(this.map);
            }
            else {
              listToaDoPolygon.push([Number(CompanyInfoVungTrongToaDo.KinhDo), Number(CompanyInfoVungTrongToaDo.ViDo)]);
            }
          }
          listPolygon.push(listToaDoPolygon);
          let layerID = 'Layer_CompanyInfoVungTrongToaDo';
          let sourceID = 'Source_CompanyInfoVungTrongToaDo';

          this.map.on('load', () => {
            this.map.addSource(sourceID, {
              'type': 'geojson',
              'data': {
                'type': 'Feature',
                'properties': {
                  "name": "VÙng trồng",
                  "address": "",
                },
                'geometry': {
                  'type': 'Polygon',
                  'coordinates': listPolygon,
                }
              }
            });
            let color = this.DownloadService.GetRandomColor(listPolygon.length);
            this.map.addLayer({
              'id': layerID,
              'type': 'fill',
              'source': sourceID,
              'paint': {
                'fill-color': color,
                'fill-opacity': 0.5,
                'fill-outline-color': color,
              }
            });
          });
        }
      }
    }
  }
}

